<template>
  <b-button-group class="ml-2">
    <b-button v-if="isMain" type="button" variant="light" @click="cancel">
      <i class="icon-cross2"></i>
      {{ buttonText }}
    </b-button>

    <b-dropdown v-else right split variant="light" @click="cancel">
      <template v-slot:button-content>
        <i class="icon-cross2"></i>
        {{ $t('bookings.cancel_this') }}
      </template>
      <b-dropdown-item @click="cancelWithMain">
        <i class="icon-cross2"></i>
        {{ $t('bookings.cancel_with_main') }}
      </b-dropdown-item>
    </b-dropdown>
  </b-button-group>
</template>

<script>
export default {
  name: 'BookingCancelBtn',

  props: {
    isMain: {
      required: true,
      type: Boolean,
    },
    buttonText: {
      required: true,
      type: String,
    },
  },

  methods: {
    cancel() {
      this.$emit('click', false)
    },
    cancelWithMain() {
      this.$emit('click', true)
    },
  },
}
</script>
